import React from 'react';
import Link from 'gatsby-link';

const styles = {
  container: {
    height: '100vh',
    overflow: 'hidden',

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    textAlign: 'center',
  },
};

const NotFoundPage = () => (
  <div style={styles.container}>
    <h1>You hit a route that doesn&#39;t exist...</h1>
    <Link to="/">Maybe go back to our <b>home</b></Link>
  </div>
);

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/404.jsx